<div class="pt-2 ps-3" *ngIf="constructorData">
  <div class="connection-list-container">
    <div *ngIf="constructorData.body">
      <div
        *ngIf="constructorData?.body?.length > 0"
        [ngClass]="'grid-container-' + header.length"
        class="hide-element header-border"
      >
        <div *ngIf="header.includes(columns.USER); else entityTitle" data-test-id="user-header">
          <div class="d-flex align-items-center">
            <app-sort-icon-item
              [sortParams]="nameSortIconParams"
              [title]="'TABLE_HEAD_USER'"
              [isLoading]="isLoading"
              (toggleSorting)="toggleSortingOrder($event)"
            ></app-sort-icon-item>
          </div>
        </div>
        <div *ngIf="header.includes(columns.SPECIALTIES)" [attr.data-test-id]="'specialties-' + 'header'">
          <div class="d-flex align-items-center">
            <span class="header-font" data-test-id="header-title-specialties">
              {{ 'TABLE_HEAD_SPECIALTIES' | translate }}
            </span>
          </div>
        </div>
        <div *ngIf="header.includes(columns.DISEASES)" [attr.data-test-id]="'diseases-' + 'header'">
          <div class="d-flex align-items-center">
            <span class="header-font" data-test-id="header-title-diseases">
              {{ 'TABLE_HEAD_DISEASES' | translate }}
            </span>
          </div>
        </div>
        <div *ngIf="header.includes(columns.LAST_VISIT)" [attr.data-test-id]="'last-visit-' + 'header'">
          <div class="d-flex align-items-center">
            <span class="header-font" data-test-id="header-title-last-visit">
              {{ 'TABLE_HEAD_LAST_VISIT' | translate }}
            </span>
          </div>
        </div>
        <div *ngIf="header.includes(columns.DATE)" data-test-id="date-header">
          <div class="d-flex align-items-center">
            <app-sort-icon-item
              [isLoading]="isLoading"
              [title]="'TABLE_HEAD_DATE'"
              [sortParams]="dateSortIconParams"
              (toggleSorting)="toggleSortingOrder($event)"
            ></app-sort-icon-item>
          </div>
        </div>
        <div *ngIf="header.includes(columns.REGISTRATION_DATE)" data-test-id="registration-date-header">
          <div class="d-flex align-items-center">
            <app-sort-icon-item
              [isLoading]="isLoading"
              [title]="'TABLE_REGISTRATION_DATE_HEAD'"
              [sortParams]="dateSortIconParams"
              (toggleSorting)="toggleSortingOrder($event)"
            ></app-sort-icon-item>
          </div>
        </div>
        <div *ngIf="header.includes(columns.DEACTIVATIONS)" [attr.data-test-id]="'deactivations-' + 'header'">
          <div class="d-flex align-items-center">
            <span class="header-font" data-test-id="header-title-deactivations">
              {{ 'TABLE_HEAD_DEACTIVATIONS' | translate }}
            </span>
          </div>
        </div>
        <div *ngIf="header.includes(columns.DESCRIPTION)" [attr.data-test-id]="'description-' + 'header'">
          <div class="d-flex align-items-center">
            <span class="header-font" data-test-id="header-title-description">
              {{ 'TABLE_HEAD_DESCRIPTION' | translate }}
            </span>
          </div>
        </div>
        <div *ngIf="header.includes(columns.MANAGE)" data-test-id="manage-header">
          <span class="header-font" data-test-id="header-title-manage">
            {{ 'TABLE_HEAD_MANAGE' | translate }}
          </span>
        </div>
      </div>
      <ng-container>
        <app-filter-drop-down
          *ngIf="filter"
          [isLoading]="isLoading"
          [hideElement]="!(isMobile$ | async)"
          [filter]="filter"
          [selectedFilter]="currentFilterCategory"
          (filterSelected)="applyFilterByCategory($event)"
        >
        </app-filter-drop-down>

        <ng-container *ngIf="isMobile$ | async">
          <app-sort-drop-down
            *ngIf="constructorData.body.length"
            [ascending]="ascending"
            [currentSortCategory]="currentSortCategory"
            [isLoading]="isLoading"
            [sortOptions]="sortOptions"
            (toggleSortingByType)="toggleSortingOrderByType($event)"
          >
          </app-sort-drop-down>
        </ng-container>
      </ng-container>

      <div *ngIf="!isLoading">
        <div
          *ngFor="let rowData of constructorData.body; index as index"
          [attr.data-test-id]="'row-' + index"
          [ngClass]="'grid-container-' + header.length"
          class="row-item"
          [attr.id]="rowData.entityId ? rowData.entityId : 'row-' + index"
        >
          <div *ngIf="rowData.user; else entityCell">
            <app-user-basic
              [user]="rowData.user"
              [accessForAdmin]="rowData.accessForAdmin"
              [srtIndex]="index + ''"
              [hasConnectionSizeLimit]="false"
            >
              <div *ngIf="isMobile$ | async">
                <span
                  *ngIf="rowData.created"
                  class="d-block display_date mb-0"
                  [attr.data-test-id]="'connection-display_date-' + index"
                  >{{ rowData.created }}</span
                >
                <span
                  *ngIf="header.includes(columns.SPECIALTIES) || header.includes(columns.DISEASES)"
                  class="dotted-text w-75"
                  [attr.data-test-id]="'specialties-diseases-cell-' + index"
                  >{{ rowData.list | representList }}</span
                >
                <span
                  *ngIf="header.includes(columns.DEACTIVATIONS)"
                  class="dotted-text w-75"
                  [attr.data-test-id]="'deactivations-cell-' + index"
                  >({{ rowData.deactivations }})</span
                >

                <span *ngIf="header.includes(columns.DESCRIPTION)" [attr.data-test-id]="'description-cell-' + index"
                  ><app-dotdotdot [innerText]="rowData.description" [numberLines]="1"> </app-dotdotdot
                ></span>
              </div>
            </app-user-basic>
          </div>
          <ng-container *ngIf="!(isMobile$ | async)">
            <span
              *ngIf="header.includes(columns.SPECIALTIES) || header.includes(columns.DISEASES)"
              class="d-block display_date mb-0 dotted-text w-75"
              [attr.data-test-id]="'specialties-diseases-cell-' + index"
              >{{ rowData.list | representList: null : NOT_SPECIFIED_HINT }}</span
            >
          </ng-container>
          <ng-template #entityCell>
            <div class="entity-view">
              <div>
                <a class="dotted-text w-100 limit-w" [routerLink]="[rowData.link + rowData.entityId]">
                  {{ rowData.entity.title }}
                </a>
              </div>
              <ng-container *ngIf="isMobile$ | async">
                <span
                  *ngIf="rowData.created"
                  class="d-block display_date mb-0"
                  [attr.data-test-id]="'connection-display_date-' + index"
                >
                  {{ rowData.created }}
                </span>
              </ng-container>
            </div>
          </ng-template>

          <div *ngIf="header.includes(columns.LAST_VISIT) && !(isMobile$ | async)">
            <span class="d-block display_date mb-0" [attr.data-test-id]="'last-visit-cell-' + index">{{
              rowData.last_visit | date: DATE_TIME_FORMAT_SHORT
            }}</span>
          </div>

          <div *ngIf="!(isMobile$ | async)">
            <span
              *ngIf="rowData.created"
              class="d-block display_date mb-0"
              [attr.data-test-id]="'connection-display_date-' + index"
              >{{ rowData.created }}</span
            >
          </div>

          <div *ngIf="rowData.deactivations && !(isMobile$ | async)">
            <span
              *ngIf="header.includes(columns.DEACTIVATIONS)"
              class="dotted-text w-75"
              [attr.data-test-id]="'deactivations-cell-' + index"
              >{{ rowData.deactivations }}</span
            >
          </div>

          <div *ngIf="rowData.description && !(isMobile$ | async)">
            <span *ngIf="header.includes(columns.DESCRIPTION)" [attr.data-test-id]="'description-cell-' + index"
              ><app-dotdotdot [innerText]="rowData.description" [numberLines]="1"> </app-dotdotdot
            ></span>
          </div>

          <div
            *ngIf="constructorData.attribute"
            [attr.id]="'table-cell-' + constructorData.attribute.key"
            [attr.class]="'table-cell-' + constructorData.attribute.key"
          >
            <ng-container
              dynamicTable
              [tableCellAttribute]="constructorData.attribute"
              [tableRowData]="rowData"
              [rowIndex]="index"
              [cellIndex]="index"
              [tooltipValues]="constructorData.body[index].tooltipValues ?? ''"
              (action)="onAction($event)"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isLoading" class="spinner-grow text-primary load m-5" role="status" data-test-id="loading-spinner">
      <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
    </div>
  </div>
  <div *ngIf="!constructorData.body.length && !isLoading && noUsersHint" class="p-3">
    <h4 class="pt-1 pb-4" data-test-id="no-items-hint">
      {{ noUsersHint | translate }}
    </h4>
  </div>
</div>

<ng-template #entityTitle>
  <div class="d-flex align-items-center" [attr.data-test-id]="header[0]?.toLowerCase() + '-header'">
    <app-sort-icon-item
      [sortParams]="nameSortIconParams"
      [title]="header[0] ?? ''"
      [isLoading]="isLoading"
      (toggleSorting)="toggleSortingOrder($event)"
    ></app-sort-icon-item>
  </div>
</ng-template>

<ngb-pagination
  *ngIf="pagination && totalCount > pageSize"
  class="w-100 d-flex justify-content-center pagination custom-pagination"
  data-test-id="pagination-component"
  [collectionSize]="totalCount"
  [(page)]="currentPage"
  [maxSize]="3"
  [pageSize]="pageSize"
  [rotate]="true"
  (pageChange)="onPageChange($event)"
>
</ngb-pagination>
